import { Inject, Injectable, Injector } from '@angular/core';

import { Inventory_ReportService } from './Inventory.report.index';
import { FootPrintApiManager_ReportService } from './FootPrintApiManager.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Inventory = this.injector.get(Inventory_ReportService);
    this.FootPrintApiManager = this.injector.get(FootPrintApiManager_ReportService);
  }
    public Inventory: Inventory_ReportService;
    public FootPrintApiManager: FootPrintApiManager_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

